/**
 * Licensed Materials - Property of IBM
 * 5737-M66, 5900-AAA, 5900-A0N, 5725-S86, 5737-I75
 * © Copyright IBM Corp. 2020, 2023 All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication, or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import get from 'lodash/get';

import {
  GET_DOMAINS,
  GET_DOMAINS_FAILURE,
  GET_DOMAINS_SUCCESS,
} from '../actions/domainActionCreators';

import { defaultFetchState } from 'reducerUtils';

// reducer
export const domainReducer = (state = defaultFetchState, action) => {
  switch (action.type) {
    case GET_DOMAINS:
      return {
        ...state,
        fetchingData: true,
        fetchDataError: null,
      };
    case GET_DOMAINS_FAILURE:
      return {
        ...state,
        fetchingData: false,
        fetchDataError: action.payload,
      };
    case GET_DOMAINS_SUCCESS:
      return {
        ...state,
        fetchingData: false,
        fetchDataError: null,
        data: action.payload,
      };
    default: {
      return state;
    }
  }
};

/**
 * Selector that returns a single domain from the redux store
 */
export const getDomain = (state, domainId) =>
  Object.values(get(state, ['domains', 'data', domainId]) || {});

/**
 * Selector that returns all domains
 */
export const getDomains = state => get(state, `domains.data`) || {};

export const isDomainsFetching = state => get(state, 'domains.fetchingData');
